import * as Yup from "yup";

export const updateTaskValidationSchema = Yup.lazy((values) =>
    Yup.object({
        name: Yup.string().required("Required field").max(100),
        description: Yup.string(),
        status: Yup.string().required("Required field"),
        assigneeUser: Yup.object().nullable().notRequired(),
        notifyBeforeDueDate: Yup.boolean().notRequired().nullable(),
        notifyBeforeDueDateInterval:
            Boolean(values.notifyBeforeDueDate) || Boolean(values.changeNotifyBeforeDueDateValues)
                ? Yup.number()
                      .integer("Decimals are not allowed here")
                      .positive("A positive number is required")
                      .min(1, "The interval must be greater than or equal to 1")
                      .required("Required field")
                      .test("is-due-date-valid", "This task does not have a Due Date", () => values.dueDate)
                : Yup.number().nullable(),
        notifyBeforeDueDateTimeUnit:
            Boolean(values.notifyBeforeDueDate) || Boolean(values.changeNotifyBeforeDueDateValues)
                ? Yup.string().required("Required field")
                : Yup.string().nullable(),
    })
);

export const addTaskValidationSchema = Yup.lazy((values) =>
    Yup.object({
        name: Yup.string().required("Required field").max(100),
        description: Yup.string(),
        assigneeUser: Yup.object().nullable().notRequired(),
        allowAssigneesReassign: Yup.boolean(),
        dueDate: Boolean(values.notifyBeforeDueDate)
            ? Yup.date().nullable().required("Required field")
            : Yup.date().nullable().notRequired(),
        notifyBeforeDueDate: Yup.boolean().notRequired().nullable(),
        notifyBeforeDueDateInterval: Boolean(values.notifyBeforeDueDate)
            ? Yup.number()
                  .nullable()
                  .integer("Decimals are not allowed here")
                  .positive("A positive number is required")
                  .min(1, "The interval must be greater than or equal to 1")
                  .required("Required field")
            : Yup.number().nullable(),
        notifyBeforeDueDateTimeUnit: Boolean(values.notifyBeforeDueDate)
            ? Yup.string().required("Required field")
            : Yup.string().nullable(),
    })
);
